import { render, staticRenderFns } from "./MarketplaceReviewsTableMobile.vue?vue&type=template&id=28313b3a&scoped=true"
import script from "./MarketplaceReviewsTableMobile.vue?vue&type=script&lang=js"
export * from "./MarketplaceReviewsTableMobile.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceReviewsTableMobile.vue?vue&type=style&index=0&id=28313b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28313b3a",
  null
  
)

export default component.exports